import React from "react";
import { NavLink } from "react-router-dom"; 
import { Main, Body, Box, TextBox, Nav } from './commonStyles';
import SafeTextToHTML from "../components/SafeTextToHTML";

export default function Legal({content, smallWindow}) {

    return(
        <>
        <Main content={content.styles}>
            <p>&nbsp;</p>
            <h2 id='Terms'>&nbsp;Terms of Use</h2>
            <Body content={{smallWindow: smallWindow}}>
                <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                    <TextBox>
                        <SafeTextToHTML text={content.legal.terms} />
                        <p>&nbsp;</p>
                        <Nav content={content.styles}>&nbsp;<NavLink to="/about"><u>Contact us</u></NavLink></Nav>
                    </TextBox>
                </Box>
            </Body>
            
            <h2 id='Privacy'>&nbsp;Privacy Policy</h2>
            <Body content={{smallWindow: smallWindow}}>
                <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                    <TextBox>
                        <SafeTextToHTML text={content.legal.privacy} />
                        <p>&nbsp;</p>
                        <Nav content={content.styles}>&nbsp;<NavLink to="/about"><u>Contact us</u></NavLink></Nav>
                    </TextBox>
                </Box>
            </Body>

            {(content.legal.complaints && content.legal.complaints.length>0) ?
                <>
                <h2 id='Complaints'>&nbsp;Complaints</h2>
                <Body content={{smallWindow: smallWindow}}>
                    <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                        <TextBox>
                            <SafeTextToHTML text={content.legal.complaints} />
                            <p>&nbsp;</p>
                            <Nav content={content.styles}>&nbsp;<NavLink to="/about"><u>Contact us</u></NavLink></Nav>
                        </TextBox>
                    </Box>
                </Body>
                </>
             : null}
        </Main>
        </>
    )
}

